import { gql } from '@common/hooks';
import {
  AppSearchWorksProfileFragment,
  AppSearchWorksProfileFragmentType,
} from '@institutions/graphql';

export const WorksAutocompleteSearchQuery = gql`
  query WorksAutocompleteSearchQuery($searchQuery: String!) {
    worksAutocompleteSearch(searchQuery: $searchQuery) {
      canShowStaffingRequestApplications {
        value
      }
      canShowStaffingRequestAssignments {
        value
      }
      canShowWorksProfiles {
        value
      }
      canShowStaffingRequests {
        value
      }
      canShowWorkers {
        value
      }
      isOrg
      staffingRequests {
        id
        name
        state
        code
      }
      worksProfiles {
        ...AppSearchWorksProfileFragment
      }
      staffingRequestApplications {
        id
        state
        worksProfile {
          ...AppSearchWorksProfileFragment
        }
        staffingRequest {
          id
          code
          name
        }
      }
      staffingRequestAssignments {
        id
        state
        staffingRequestType
        worker {
          id
        }
        worksProfile {
          ...AppSearchWorksProfileFragment
        }
        staffingRequest {
          id
          code
          name
        }
      }
      workers {
        id
        isInternal
        worksUser {
          id
          name
        }
      }
    }
  }
  ${AppSearchWorksProfileFragment}
`;

type NeedToFixListsAtBackend = undefined;

export type WorksAutocompleteSearchResponse = {
  worksAutocompleteSearch: {
    canShowStaffingRequestApplications: { value: boolean };
    canShowStaffingRequestAssignments: { value: boolean };
    canShowWorksProfiles: { value: boolean };
    canShowStaffingRequests: { value: boolean };
    canShowWorkers: { value: boolean };
    isOrg: boolean;
    staffingRequests:
      | {
          id: string;
          name: string;
          state:
            | 'CANCELLED'
            | 'FILLED'
            | 'ON_HOLD'
            | 'OPEN'
            | 'PENDING'
            | 'REJECTED_BY_APPROVER';
          code: string;
        }[]
      | NeedToFixListsAtBackend;
    worksProfiles:
      | AppSearchWorksProfileFragmentType[]
      | NeedToFixListsAtBackend;
    staffingRequestApplications:
      | {
          id: string;
          state: string;
          worksProfile: AppSearchWorksProfileFragmentType;
          staffingRequest: {
            id: string;
            code: string;
            name: string;
          };
        }[]
      | NeedToFixListsAtBackend;
    staffingRequestAssignments:
      | {
          id: string;
          state: string;
          staffingRequestType: 'long_term' | 'on_demand';
          worker: {
            id: string;
          };
          worksProfile: AppSearchWorksProfileFragmentType;
          staffingRequest: {
            id: string;
            code: string;
            name: string;
          };
        }[]
      | NeedToFixListsAtBackend;
    workers:
      | {
          id: string;
          isInternal: boolean;
          worksUser: {
            id: string;
            name: string;
          };
        }[]
      | NeedToFixListsAtBackend;
  };
};

export type WorksAutocompleteSearchArgs = {
  searchQuery: string;
};
